module.exports = __webpack_public_path__ + "img/为客户ico.07333b56.png";